.welcome {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-5);
  padding: var(--tuna-spacing-4);
}

.intro {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.title {
  font-size: var(--tuna-typography-h2-fontSize);
  margin: 0;
}

.tagline {
  color: var(--tuna-content-secondary);
  margin: 0;
}

.idiomPicker {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-subtle, var(--tuna-palette-grey-300));
  border-radius: var(--tuna-shape-borderRadius);
  padding: var(--tuna-spacing-3);
}

.idiomLegend {
  font-weight: 600;
  padding: 0 var(--tuna-spacing-1);
}

.idiomButtons {
  display: flex;
  gap: var(--tuna-spacing-2);
  flex-wrap: wrap;
}

.idiomButton {
  min-width: 96px;
}

.idiomBody {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body2-fontSize);
  margin: 0;
}

.subModeGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--tuna-spacing-3);
}

.subModeCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: var(--tuna-spacing-4);
  min-height: 120px;
}

.subModeCard[aria-pressed='true'] {
  outline: 2px solid var(--tuna-palette-primary-500);
  outline-offset: 2px;
}

.cardTitle {
  font-size: var(--tuna-typography-h3-fontSize);
  font-weight: 600;
  margin-bottom: var(--tuna-spacing-1);
}

.cardBody {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body-fontSize);
}

@media (max-width: 640px) {
  .subModeGrid {
    grid-template-columns: 1fr;
  }
}
